import React from 'react';
import styled from 'styled-components';
import {
  InfoCircleFilled,
  CheckCircleFilled,
  WarningFilled,
} from '@ant-design/icons';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

const TONE_STYLE = {
  info: {
    accent: COLOR.primary,
    background: COLOR.primaryLight,
    icon: InfoCircleFilled,
  },
  success: {
    accent: COLOR.success,
    background: COLOR.successBackground,
    icon: CheckCircleFilled,
  },
  warning: {
    accent: COLOR.warning,
    background: COLOR.warningBackground,
    icon: WarningFilled,
  },
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md};
  margin-bottom: ${SPACING.lg};
  padding: ${SPACING.md} ${SPACING.lg};
  border-left: 3px solid ${({ accent }) => accent};
  border-radius: 0 ${RADIUS.card} ${RADIUS.card} 0;
  background: ${({ background }) => background};

  .anticon {
    flex: none;
    margin-top: 3px;
    color: ${({ accent }) => accent};
  }
`;

const Content = styled.p`
  margin: 0;
  font-size: ${FONT_SIZE.body};
  line-height: 1.55;
  color: ${COLOR.navy};
`;

const Note = ({ tone = 'info', children }) => {
  const {
    accent,
    background,
    icon: ToneIcon,
  } = TONE_STYLE[tone] || TONE_STYLE.info;

  return (
    <Container accent={accent} background={background}>
      <ToneIcon />
      <Content>{children}</Content>
    </Container>
  );
};

export default Note;
